import styles from "./styles.module.scss";

interface TypesRow {
  children: React.ReactNode;
  isFirstRowHomepage?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export const Row = ({
  children,
  isFirstRowHomepage = false,
  style = null,
  className,
}: TypesRow) => {
  const customClass = [
    isFirstRowHomepage ? styles.rowIsFirstRowHomepage : styles.row,
    className,
  ]
    .filter((className) => className)
    .join(" ");

  return (
    <div style={style} className={customClass}>
      {children}
    </div>
  );
};
